import { Component, OnInit } from '@angular/core';
import { PerformanceLandingPageHandler } from './performance-landing-page.handler.';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../services/dashboard.service';

@Component({
  selector: 'sym-performance-landing-page',
  templateUrl: './performance-landing-page.component.html',
  styleUrls: ['./performance-landing-page.component.scss'],
})
export class PerformanceLandingPageComponent extends PerformanceLandingPageHandler implements OnInit {
  constructor(
    public service: DashboardService,
    public headerService: HeaderService,
    public router: Router,
    public route: ActivatedRoute,
    public settingService: SettingService
  ) {
    super(service, headerService, router, route, settingService);
  }
}
